export default "__VITE_ASSET__pqFw8c$3__"